import datepicker from 'bootstrap-datepicker';

$.get('/api/datepicker/placement-dates', {}, function(placementDates)
{
    $('.datepicker-placement-date').datepicker({
        format: 'dd/mm/yyyy',
        orientation: 'bottom',
        autoclose: true,
        calendarWeeks: true,
        weekStart: 1,
        beforeShowDay: function(date){
            const formattedDate = date.toLocaleString('nl-BE', {day: '2-digit', month: '2-digit', year: 'numeric'})
            const keys = Object.keys(placementDates);

            if (keys.includes(formattedDate)){

                return {classes: 'bg-info text-light', tooltip: placementDates[formattedDate]};
            }
            else {

                return;
            }
        },
    }).on('changeDate', function(e) {
        $('#datepicker-placement-date-input').val(e.format('dd/mm/yyyy'));
    });

    if (initialPlacementDate) {
        $('.datepicker-placement-date').datepicker('setDate', initialPlacementDate);
    }

    $('#datepicker-placement-date-clear').click(function(e) {
        e.preventDefault();
        $('.datepicker-placement-date').datepicker('clearDates');
        $('#datepicker-placement-date-input').val('');
    });
}).fail(function(e) {
    console.log(e);
});